import { Typography } from '@mui/material'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { i18n } from '../../index'
import IncentiveProductPage from './IncentiveProductPage'
import css from './incentiveProductPage.css'
import { salesIncentiveProductsQuery } from './incentiveProductQueries'
import type { SalesIncentiveProduct } from './incentiveProductTypes'

class ChainIncentiveProductPage extends React.Component<null, {}> {
  fetchTimeout: null | NodeJS.Timeout = null

  render() {
    return (
      <div>
        <Typography variant='h6'>{i18n.t('admin.header')}</Typography>
        <div className={css.top}>
          <Typography variant='h6'>{i18n.t('admin.incentiveProducts.pageTitle')}</Typography>
        </div>
        <Query<
          {
            salesIncentiveProducts: Array<SalesIncentiveProduct>
          },
          {}
        >
          query={salesIncentiveProductsQuery}
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <IncentiveProductPage
                variables={{}}
                incentiveSalesTarget={{}}
                incentiveSalesWeights={[]}
                incentiveSalesProducts={get(data, 'salesIncentiveProducts', [])}
                incentiveSalesTargetNextYear={{}}
              />
            </Loader>
          )}
        </Query>
      </div>
    )
  }
}

export default ChainIncentiveProductPage
